import { i18next } from '@frontend/i18n';
import { FormConfig } from '@frontend/design-system';
import { dropdownField, listField, phoneField, switchField, textField } from '../../../utils/field-config-helpers';
import { ToggleKey } from './fields';

export type NotificationsFieldsTypes = typeof notificationsFields;
export const notificationsFields = {
  communicationMethod: dropdownField(),
  practiceEmail: textField({
    validator: ({ value }) => {
      if (!value) return '';
      const emails = value.split(',').map((email) => email.trim());
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const hasValidEmails = emails.every((email) => emailRegex.test(email));
      return hasValidEmails ? '' : i18next.t('Please enter valid email addresses, separated by commas if multiple');
    },
  }),
  practicePhoneNumber: phoneField(),

  patientEmergencyEmail: listField(),
  patientEmergencyPhoneNumber: listField(),

  toggle1: switchField(),
  toggle2: switchField(),
  toggle3: switchField(),
  toggle4: switchField(),
  toggle5: switchField(),
  toggle6: switchField(),
  toggle7: switchField(),
  toggle8: switchField(),
  toggle9: switchField(),

  voicemailResponse: dropdownField(),
  helpGettingIn: textField(),
  runningLate: textField(),
} satisfies FormConfig;

export const NOTIFICATION_TOGGLES: { key: ToggleKey; labelKey: string }[] = [
  {
    key: 'toggle1',
    labelKey:
      'Notify me if some business information needs to be provided to help my AI Receptionist handle calls better',
  },
  {
    key: 'toggle2',
    labelKey: 'Notify me if my AI Receptionist is unable to complete a booking/reschedule/cancel',
  },
  {
    key: 'toggle3',
    labelKey: 'Notify me when a booking/cancel or reschedule is made',
  },
  {
    key: 'toggle4',
    labelKey: 'Notify me if my AI Receptionist will make a booking/reschedule or cancel within the next (?) hours:',
  },
  {
    key: 'toggle5',
    labelKey: 'Notify me when a customer has an issue with billing or credit card',
  },
  {
    key: 'toggle6',
    labelKey: 'Notify me about Unresponsive/Callback/Landline customer',
  },
  {
    key: 'toggle7',
    labelKey: 'Notification for miscellaneous requests (Sales, Job, etc. )',
  },
  {
    key: 'toggle8',
    labelKey: 'Notify me if a customer needs help getting in or is running late',
  },
  {
    key: 'toggle9',
    labelKey: 'Notify me if guest wants to be added to the waitlist',
  },
];
